const getDefaultDbState = () => {
	return {
		organization: {},
		organizer: {},
		eventbasics: [],
		evcatas: [],
		eventbasic: {},
		evoptions: [],
		evsections: [],
		signforms: [],
		evid: '',
		new_eventbasic: {},
		new_evoptions: [],
		new_evsections: [],
		sysorder: {},
		sysorderitems: [],
		enabled_modules: [],
	};
};

const DbModule = {
	namespaced: false,
	state: getDefaultDbState(),
	getters: {
		getDb(state) {
			return state;
		},
	},
	mutations: {
		resetDb(state) {
			console.log(`vuex, reset-db state=`, getDefaultDbState());
			Object.keys(state).forEach(key => {
				delete state[key];
			});
			Object.assign(state, getDefaultDbState());
		},
		changeDb(state, { name, value }) {
			console.log(`vuex, change-db, before, name=${name}, value=`, value);

			// ** Object.assign() 只能用於「物件」的合併**，不能用來處理「陣列」或「字串」這種非物件型別的值。
			if (Array.isArray(value) || typeof value !== 'object' || value === null) {
				state[name] = value;
			} else {
				Object.assign(state[name], value);
			}

			console.log(`vuex, change-db, after, name=${name}, value=`, state[name]);
		},
		deleteDb(state, { name }) {
			delete state[name];
		},
		changeDbObject(state, { value }) {
			// 刪除 state 上不在 value 裡的 key
			Object.keys(state).forEach(key => {
				if (value !== undefined) {
					if (!(key in value)) {
						delete state[key];
					}
				}
			});
			// 再把 value 裡的屬性都 assign 過來
			Object.assign(state, value);
		},
	},
	actions: {
		resetDb({ commit }) {
			console.log(`vuex store, setting, actions: reset state`);
			commit('resetDb');
		},
		changeDb({ commit }, { name, value }) {
			commit('changeDb', { name, value });
		},
		deleteDb({ commit }, { name }) {
			commit('deleteDb', { name });
		},
		changeDbObject({ commit }, { value }) {
			commit('changeDbObject', { value });
		},
	},
};

export default DbModule;
